module.exports = __webpack_public_path__ + "img/695.7c237de6.png";